import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
const sitemapSections = [{
  title: 'Main Pages',
  links: [{
    label: 'Home',
    href: '/'
  }, {
    label: 'About AccuTemp',
    href: '/about'
  }, {
    label: 'Why AccuTemp',
    href: '/why-accutemp'
  }, {
    label: 'Contact',
    href: '/contact'
  }]
}, {
  title: 'Services',
  links: [{
    label: 'All Services',
    href: '/services'
  }, {
    label: 'Installation',
    href: '/services/installation'
  }, {
    label: 'Maintenance',
    href: '/services/maintenance'
  }, {
    label: 'TM44 Compliance',
    href: '/services/tm44'
  }, {
    label: 'Ventilation',
    href: '/services/ventilation'
  }, {
    label: 'Ducted Systems',
    href: '/services/ducted'
  }, {
    label: 'Cassette Systems',
    href: '/services/cassette'
  }, {
    label: 'Wall Mounted Systems',
    href: '/services/wall-mounted'
  }]
}, {
  title: 'Case Studies',
  links: [{
    label: 'All Case Studies',
    href: '/case-studies'
  }, {
    label: 'Automotive Industry',
    href: '/case-studies/formula-one'
  }, {
    label: 'Subway',
    href: '/case-studies/subway'
  }, {
    label: 'Process Cooling',
    href: '/case-studies/process-cooling'
  }]
}, {
  title: 'Knowledge Hub',
  links: [{
    label: 'All Resources',
    href: '/knowledge-hub'
  }, {
    label: 'Compliance',
    href: '/knowledge-hub/compliance'
  }, {
    label: 'Maintenance Guide',
    href: '/knowledge-hub/maintenance-guide'
  }, {
    label: 'Installation Guide',
    href: '/knowledge-hub/installation-guide'
  }, {
    label: 'Repairs & Efficiency',
    href: '/knowledge-hub/repairs-efficiency'
  }, {
    label: 'Eco Ventilation',
    href: '/knowledge-hub/eco-ventilation'
  }, {
    label: 'System Guides',
    href: '/knowledge-hub/system-guides'
  }]
}];
export function Sitemap() {
  return <main className="min-h-screen font-sans bg-white pt-28" data-id="element-2563">
      {/* Header */}
      <section className="container mx-auto px-6 pb-16 pt-8" data-id="element-2564">
        <span className="text-sm uppercase tracking-wider font-medium text-primary-dark/40 mb-4 block" data-id="element-2565">
          Navigation
        </span>
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary-dark leading-tight tracking-tight" data-id="element-2566">
          Sitemap
        </motion.h1>
        <p className="text-lg text-primary-dark/60 mt-4 max-w-xl" data-id="element-2567">
          A complete overview of all pages on the AccuTemp website.
        </p>
      </section>

      {/* Sitemap Grid */}
      <section className="container mx-auto px-6 pb-24" data-id="element-2568">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-2569">
          {sitemapSections.map((section, sIdx) => <motion.div key={section.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: sIdx * 0.1
        }} data-id="element-2570">
              <h2 className="text-xs font-bold uppercase tracking-widest text-primary-dark/40 mb-6 pb-3 border-b border-primary-dark/10" data-id="element-2571">
                {section.title}
              </h2>
              <ul className="space-y-3" data-id="element-2572">
                {section.links.map(link => <li key={link.href} data-id="element-2573">
                    <Link to={link.href} className="group flex items-center gap-2 text-primary-dark/80 hover:text-accent transition-colors text-sm" data-id="element-2574">
                      <ChevronRightIcon className="w-3.5 h-3.5 text-primary-dark/20 group-hover:text-accent transition-colors" data-id="element-2575" />
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </section>
    </main>;
}